import { executeGetNoResultError } from '../common/apiCaller'
import { GetReductionsDto } from '../dto/reductionsDto'

const apiName = 'citizen'
const apiPath = '/reductions'

export const executeGetReductions = (id: string) => {
  return executeGetNoResultError<GetReductionsDto>(apiName, `${apiPath}/${id}`)
}
